import React, { useContext } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
// import { normalizeNumbers } from "@SeemplicityDev/shared";
import { AppPreferencesContext } from "../../../General/AppPreferencesProvider";
import { AppPreferencesContextType } from "../../../types/AppPreferencesProvider";
import useAddRef, { UseAddRefOptions } from "../useAddRef";
import { normalizeNumbers, useIcon } from "@SeemplicityDev/shared";

am4core.useTheme(am4themes_animated);
interface TagsPageProps extends UseAddRefOptions {
  data?: {
    tags: {
      tag: string;
      count: number;
    }[];
  };
  hasResourcesPage?: boolean;
}
const TagsPage: React.FC<TagsPageProps> = ({
  data,
  index,
  addRef,
  hasResourcesPage,
}) => {
  const ref = useAddRef({ addRef });
  const {
    appPreferences: { useAI },
  } = useContext(AppPreferencesContext) as AppPreferencesContextType;
  const { getSvg } = useIcon("LIGHT");

  return (
    <div className={`eoy-page tags-page`} ref={ref}>
      {!hasResourcesPage && <h3>Resources</h3>}
      <div className="title-container">
        {useAI && <img src={getSvg("icon-ai")} alt="AI" className="ai-star" />}
        <h4>Most Used Tags</h4>
        {useAI && (
          <span className="ai-text">(generated by Seemplicity AI)</span>
        )}
      </div>
      <div className="tags-container">
        {data?.tags.map((tag) => (
          <div className="tag-item" key={tag.tag}>
            <span className="tag-name">{tag.tag}</span>
            <span className="tag-count">
              ({normalizeNumbers(tag.count, 0)})
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TagsPage;
